import React from 'react';
const BrowseContext = React.createContext();

export default BrowseContext;
